import { useQuery } from "@tanstack/react-query";
import { LoyaltyRewardUser } from "types/Loyalty";
import { api } from "../utils/hostname";
import url from "../url";

const request = (params: { loyaltyId?: string; rewardId?: string }) =>
  api(true, true).get<{ data: LoyaltyRewardUser[] }>(
    url.config.api.loyalty.userRewards,
    {
      params: {
        loyaltyId: params?.loyaltyId,
        rewardId: params?.rewardId,
      },
    },
  );

export const useGetLoyaltyRewardsUser = (options: {
  rewardId?: string;
  loyaltyId?: string;
}) => {
  const { data, isLoading, isPending } = useQuery({
    queryKey: ["loyalty rewards user"],
    queryFn: () =>
      request({ loyaltyId: options?.loyaltyId, rewardId: options?.rewardId }),
    enabled: !!options?.loyaltyId,
    refetchOnWindowFocus: false,
  });

  return {
    userRewards: data?.data.data || [],
    isLoading: isLoading || isPending,
  };
};
